var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-tapwaves"},_vm._l((_vm.tapwaves),function(tapwave){return _c('div',{key:tapwave.id,staticClass:"global-tapwave",style:(Object.assign({}, tapwave.style,
      {backgroundImage: ("url('" + (_vm.cdnDeliver('/images/themes/seaborn/tapwave.png')) + "')")}))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }